import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { ButtonModule, InputFieldsModule, LoadingIndicatorsModule,
  DropdownsModule, AlertsModule, ModalsModule, CheckboxModule, ChipsModule, PopoverModule, TooltipModule} from "gds-atom-components";
import { AskOurDataService } from "@services/ask-our-data/ask-our-data.service";
import { SamplePromptsComponent } from './chat-with-db/sample-prompts/sample-prompts.component';
import { AodChatHistoryComponent } from './chat-with-db/chat-history/aod-chat-history.component';
import { TableModule } from "primeng/table";
import { ResponseFeedbackComponent  } from './chat-with-db/response-feedback/response-feedback.component'; 

@NgModule({
  declarations: [SamplePromptsComponent, AodChatHistoryComponent, ResponseFeedbackComponent],
  imports: [
    CommonModule,
    FormsModule,
    InputFieldsModule,
    LoadingIndicatorsModule,
    DropdownsModule,
    ButtonModule,
    AlertsModule,
    ModalsModule,
    CheckboxModule,
    ChipsModule,
    TableModule,
    PopoverModule,
    TooltipModule
  ],
  exports: [SamplePromptsComponent, AodChatHistoryComponent, ResponseFeedbackComponent],
  providers: [AskOurDataService],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AskOurDataSharedModule { }
